import { render, staticRenderFns } from "./meetinglistpc.vue?vue&type=template&id=2b4e3923&scoped=true&"
import script from "./meetinglistpc.vue?vue&type=script&lang=js&"
export * from "./meetinglistpc.vue?vue&type=script&lang=js&"
import style0 from "./meetinglistpc.vue?vue&type=style&index=0&id=2b4e3923&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4e3923",
  null
  
)

export default component.exports